import { Box, Collapse, Typography, IconButton } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./CohortCategoryCard.css";
import useTranslationSetup from "../../utils/useTranslationSetup";

const CohortCategoryCard = ({
  title,
  count,
  icon,
  isOpen,
  onToggle,
  children,
  className,
  cardDescription,
  descriptionKey,
  infoBanner,
}) => {
  const { t, tSubject } = useTranslationSetup();
  const description = descriptionKey
    ? tSubject(descriptionKey)
    : cardDescription;
  return (
    <Box
      className={`cohort-category-card-container ${isOpen ? "container-expanded" : ""} ${className}-border`}
    >
      <Box
        className={`cohort-category-card ${isOpen ? "expanded" : ""} ${className}-bg`}
        onClick={onToggle}
      >
        <Box className="cohort-category-card-icon">
          <img src={icon} alt="Icon" className="cohort-card-icon" />
        </Box>
        <Box className="cohort-category-card-title">
          <Typography className="cohort-category-card-heading">
            {title}
          </Typography>
          <Typography className="cohort-card-count">
            {count} {t("students")}
          </Typography>
        </Box>
        <IconButton>
          {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      {isOpen && description && (
        <Box className={`cohort-metric-wrapper ${className}-bg`}>
          <Typography className="cohort-metric-label">
            {description}
          </Typography>
        </Box>
      )}

      {isOpen && infoBanner && (
        <Box className="cohort-card-info-banner-wrapper">
          <img
            src={infoBanner}
            alt="Information icon"
            className="cohort-card-info-banner-icon"
          />
          <Typography className="cohort-card-info-banner-text">
            {t("unassigned_cohort_reassessment_info")}
          </Typography>
        </Box>
      )}

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Box className="cohort-children-wrapper">{children}</Box>
      </Collapse>
    </Box>
  );
};

export default CohortCategoryCard;
